import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import UserContext from "../../context/userContext";
import "./styles/RegisterOptions.scss";
import RegisterCard from "../../components/RegisterCard/RegisterCard";
import MasksIcon from "../../components/VectorIcons/Masks";
import Microphone from "../../components/VectorIcons/Microphone";
import Clipboard from "../../components/VectorIcons/Clipboard";
import RoundCloseButton from "../../components/RoundCloseButton/RoundCloseButton";
import LiteraryWorkIcon from "../../components/VectorIcons/LiteraryWorkIcon";

const RegisterOptions = () => {
  const { hasPermission } = useContext(UserContext);
  const navigate = useNavigate();

  return (
    <div id="RegisterOptions">
      <Helmet>
        <title>Script - Cadastro de Projetos</title>
      </Helmet>
      <div className="closeButton" onClick={() => navigate("/")}>
        <RoundCloseButton color="#36355A" />
      </div>
      <span className="optionsTitle">O que você quer cadastrar?</span>
      <span className="optionsSubTitle">Escolha uma opção</span>
      <div className="cardsContainer">
        <RegisterCard
          option="Projeto de Dramaturgia"
          iconCollor="rgb(236, 16, 69)"
          className={
            hasPermission({ required: ["Dramaturgies"] }) ? "active" : ""
          }
          redirectTo="/cadastrar/dramaturgia"
        >
          <MasksIcon />
        </RegisterCard>

        <RegisterCard
          option="Projeto de Variedades"
          iconCollor="rgb(45, 118, 212)"
          className={hasPermission({ required: ["Varieties"] }) ? "active" : ""}
          redirectTo="/cadastrar/variedades"
        >
          <Microphone />
        </RegisterCard>

        <RegisterCard
          option="Pesquisa"
          iconCollor="rgb(0, 156, 105)"
          className={
            hasPermission({ required: ["Researches"] }) ? "active" : ""
          }
          redirectTo="/pesquisa/cadastrar"
        >
          <Clipboard />
        </RegisterCard>

        <RegisterCard
          option="Obra Literária"
          iconCollor="rgb(223, 154, 55)"
          className={
            hasPermission({ required: ["LiteraryWorks"] }) ? "active" : ""
          }
          redirectTo="/obra-literaria/cadastrar"
        >
          <LiteraryWorkIcon />
        </RegisterCard>
      </div>
    </div>
  );
};

export default RegisterOptions;
